import moment from 'moment';

const validaPeriodoRecadastramentoFamiliar = (dataFim) => {
  return moment(new Date()).isBefore(moment(dataFim, 'DD/MM/YYYY'));
}

export default validaPeriodoRecadastramentoFamiliar;



// WEBPACK FOOTER //
// ./src/router/validaPeriodoRecadastramentoFamiliar.js